import React, { Component } from 'react'
import Deposit from '../containers/Deposit'
import List from '../containers/List'
import PropTypes from 'prop-types'
import '../css/Calculator.css'

class Calculator extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="fix-margin">
          <h4 className="header">PREFFERED MONEY MARKET CALCULATOR</h4>
          <div className="deposit">
            <Deposit />
          </div>
          <div className="list">
            <List />
          </div>
        </div>
      </React.Fragment>
    )
  }
}

Deposit.propTypes = {
  onChange: PropTypes.func,
}

export default Calculator



// WEBPACK FOOTER //
// ./src/components/Calculator.js